import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { usePortalReturn } from './usePortalReturn';

const messages = defineMessages({
  working: {
    id: 'app.sml.catalog.connect.return.working',
    defaultMessage: 'Connecting {service}…',
  },
  workingBody: {
    id: 'app.sml.catalog.connect.return.workingBody',
    defaultMessage: 'MUSIC24 finishes the sign-in. Then your Catalog opens.',
  },
});

/**
 * `/app/catalog/connect/<integrationType>?state=…`: MusicAPI sends the browser back here after the
 * consent of a return-page portal (Audiomack). The page finishes the connection, then opens the
 * Catalog with the outcome.
 */
const PortalReturnPageComponent: React.FC<{ integrationType: string; serviceName: string; state: string }> = ({
  integrationType,
  serviceName,
  state,
}) => {
  const intl = useIntl();
  usePortalReturn(integrationType, state);
  return (
    <LoadingView
      label={intl.formatMessage(messages.working, { service: serviceName })}
      sublabel={intl.formatMessage(messages.workingBody)}
    />
  );
};

export const PortalReturnPage = TypedMemo(PortalReturnPageComponent);
